import { useState } from 'react';

export default function Navigation({ isScrolled }: { isScrolled?: boolean }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navigateToSchools = () => {
    window.REACT_APP_NAVIGATE('/for-schools');
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/50 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-br from-rose-400 to-pink-500 rounded-xl flex items-center justify-center">
              <i className="ri-graduation-cap-fill text-2xl text-white"></i>
            </div>
            <div>
              <div className="text-lg font-black text-gray-900">Miss Mirage</div>
              <div className="text-xs text-gray-600 font-semibold">Educator Program</div>
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('program')}
              className="text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              プログラム概要
            </button>
            <button
              onClick={() => scrollToSection('certification')}
              className="text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              認定までの道のり
            </button>
            <button
              onClick={() => scrollToSection('support')}
              className="text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              サポート体制
            </button>
            <button
              onClick={navigateToSchools}
              className="text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              スクール・サロン向け
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-3 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-sm font-bold rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('program')}
              className="block w-full text-left text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              プログラム概要
            </button>
            <button
              onClick={() => scrollToSection('certification')}
              className="block w-full text-left text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              認定までの道のり
            </button>
            <button
              onClick={() => scrollToSection('support')}
              className="block w-full text-left text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              サポート体制
            </button>
            <button
              onClick={navigateToSchools}
              className="block w-full text-left text-sm font-semibold text-gray-700 hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              スクール・サロン向け
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-6 py-3 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-sm font-bold rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
